export const DEFAULT_ATTRIBUTE_CONDITION = Object.freeze({ type: 'attribute' });
